import React from 'react'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { useSelector } from 'react-redux'
import { State } from '../types/state'
import { useIsLargeView, useIsMobileView } from '../hooks/useIsMobileView'
import { generateSubjectSelectionsReportData } from '../reports/utils'

const SubjectsStatistics = (): JSX.Element => {
  const { studentsSelections, subjects } = useSelector(
    (state: State) => state.user
  )
  const isMobileView = useIsMobileView()
  const isLargeView = useIsLargeView()

  const data = generateSubjectSelectionsReportData(
    studentsSelections,
    subjects,
    true
  )

  const columns: GridColDef[] = [
    { field: 'subject', headerName: 'Subject', width: 250 },
    {
      field: 'groupFilling',
      headerName: 'Current Group Size',
      width: 160
    },
    {
      field: 'minimalGroup',
      headerName: 'Minimum Group Size',
      width: 160
    },
    {
      field: 'percentageFilling',
      headerName: '% subject filling',
      width: 200,
      sortComparator: (a, b) => {
        const num1 = Number((a as string)?.slice(0, -1) ?? 0)
        const num2 = Number((b as string)?.slice(0, -1) ?? 0)

        return num1 - num2
      },
      renderCell: params => <PercentageFilling id={params.row.id} />
    }
  ]

  const processedData = data[0].map((_, index) => ({
    minimalGroup: data[2][index],
    groupFilling: data[1][index],
    percentageFilling: data[3][index],
    subject: data[0][index],
    id: index
  }))

  processedData.shift()

  const PercentageFilling: React.FC<{ id: number }> = ({ id }) => {
    const singleData = processedData.find(s => s.id === id)!

    const num = Number((singleData.percentageFilling as string).slice(0, -1))

    return (
      <h4 style={{ color: num < 100 ? 'red' : 'green' }}>
        {singleData.percentageFilling}
      </h4>
    )
  }

  return (
    <div
      style={{
        height: isMobileView ? '75vh' : '60vh',
        width: isMobileView ? '80vw' : isLargeView ? '50vw' : '70vw',
        margin: 'auto',
        marginBottom: '5vw'
      }}
    >
      <DataGrid
        style={{ marginTop: '5vh' }}
        disableRowSelectionOnClick
        rows={processedData}
        columns={columns}
        checkboxSelection={false}
      />
    </div>
  )
}

export default SubjectsStatistics
